export function refreshPageWithCacheClear() {

  // Clearing cache using different techniques based on browser support
  try {
    if (typeof caches !== 'undefined') {
      // Clearing cache using Service Workers (if supported)
      caches.keys().then(function (cacheKeys) {
        cacheKeys.forEach(function (cacheKey) {
          caches.delete(cacheKey);
        });
      });
    }

    if (window.hasOwnProperty('caches')) {
      // Clearing cache using CacheStorage API (if supported)
      window.caches.keys().then(function (cacheKeys) {
        cacheKeys.forEach(function (cacheKey) {
          window.caches.delete(cacheKey);
        });
      });
    }

  } catch (error) {
    console.error('error', error)
  }

  // Reloading the page
  window.location.reload(true); // Passing true as a parameter forces a server reload and cache clear on most browsers
}
